import type { GuidebookProperty, GuidebookWelcome } from "./types"

interface Props {
  property: GuidebookProperty
  welcome: GuidebookWelcome | null
  /** Voice-aware afternoon greeting variant. Falls back to "Good afternoon". */
  greetingAfternoon?: string
}

export function WelcomeCard({ property, welcome, greetingAfternoon }: Props) {
  const welcomeHeadline = (welcome?.welcome_headline || welcome?.headline || "Welcome").trim()
  const welcomeMessage = (welcome?.welcome_message || welcome?.message || "").trim()

  // Time-aware greeting (afternoon variant is voice-aware)
  const greeting = getTimeGreeting(greetingAfternoon)

  return (
    <div className="gb-welcome">
      <div className="gb-welcome__greeting">{greeting}</div>
      <h2 className="gb-welcome__headline">{welcomeHeadline}</h2>

      {welcomeMessage && (
        <p className="gb-welcome__message">{welcomeMessage}</p>
      )}

      {property.address && (
        <div className="gb-welcome__location">
          <MapPinIcon />
          <span>
            {property.address}
            {property.lat != null && property.lng != null && (
              <>
                {" — "}
                <a
                  className="gb-welcome__location-link"
                  href={`https://maps.google.com/?q=${property.lat},${property.lng}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Get directions"
                >
                  Directions
                </a>
              </>
            )}
          </span>
        </div>
      )}
    </div>
  )
}

function getTimeGreeting(afternoonVariant?: string): string {
  const hour = new Date().getHours()
  if (hour < 12) return "Good morning"
  if (hour < 17) return afternoonVariant || "Good afternoon"
  return "Good evening"
}

function MapPinIcon() {
  return (
    <svg className="gb-welcome__location-icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="9" cy="7.5" r="2.5" />
      <path d="M9 16s-5-4.5-5-8.5a5 5 0 0 1 10 0c0 4-5 8.5-5 8.5Z" />
    </svg>
  )
}
